/**
 * <store-map> — swaps the Google Maps Embed iframe between place and street view.
 *
 * Uses the Maps Embed API rather than the Maps JavaScript API: Embed is not
 * billed per load, so adding a map to 42 store pages does not move the bill.
 *
 * Degrades to a plain map iframe if this script never runs — the toggle simply
 * does nothing rather than the map disappearing.
 */
(function () {
  'use strict';

  if (customElements.get('store-map')) return;

  class StoreMap extends HTMLElement {
    connectedCallback() {
      this.frame = this.querySelector('.store-map__frame');
      this.buttons = Array.from(this.querySelectorAll('.store-map__toggle-btn'));

      if (!this.frame || this.buttons.length === 0) return;

      this.lat = this.dataset.lat;
      this.lng = this.dataset.lng;
      this.key = this.dataset.key;
      this.zoom = this.dataset.zoom || '13';

      if (!this.lat || !this.lng || !this.key) return;

      this.onClick = this.onClick.bind(this);
      this.buttons.forEach((btn) => btn.addEventListener('click', this.onClick));
    }

    disconnectedCallback() {
      this.buttons.forEach((btn) => btn.removeEventListener('click', this.onClick));
    }

    srcFor(view) {
      const base = 'https://www.google.com/maps/embed/v1/';
      const key = encodeURIComponent(this.key);
      const at = encodeURIComponent(this.lat + ',' + this.lng);

      if (view === 'street') {
        return base + 'streetview?key=' + key + '&location=' + at + '&heading=0&pitch=0&fov=90';
      }
      return base + 'place?key=' + key + '&q=' + at + '&zoom=' + encodeURIComponent(this.zoom);
    }

    onClick(event) {
      const button = event.currentTarget;
      const view = button.dataset.view;

      if (button.classList.contains('is-active')) return;

      this.buttons.forEach((btn) => {
        const active = btn === button;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      this.frame.src = this.srcFor(view);
    }
  }

  customElements.define('store-map', StoreMap);
})();
